var _path, _g, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeature2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 61,
    viewBox: "0 0 76 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1189_12466)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1189_12466",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 15,
    width: 52,
    height: 46
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.489 15.082H0V60.3603H51.489V15.082Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1189_12466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0582 49.5442C14.6998 49.5442 15.3269 49.354 15.8604 48.9975C16.3938 48.6411 16.8096 48.1345 17.0551 47.5418C17.3006 46.949 17.3648 46.2968 17.2397 45.6676C17.1145 45.0384 16.8056 44.4604 16.3519 44.0067C15.8983 43.5531 15.3203 43.2441 14.6911 43.119C14.0618 42.9938 13.4096 43.058 12.8169 43.3036C12.2242 43.5491 11.7176 43.9648 11.3611 44.4983C11.0047 45.0317 10.8145 45.6589 10.8145 46.3004C10.8145 47.1607 11.1562 47.9858 11.7645 48.5941C12.0657 48.8953 12.4233 49.1343 12.8169 49.2973C13.2104 49.4603 13.6323 49.5442 14.0582 49.5442Z",
    fill: "#63ADF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4174 21.4297H6.48756C4.76695 21.4297 3.11681 22.1132 1.90016 23.3298C0.683508 24.5465 0 26.1966 0 27.9172L0 60.3595H51.9064V27.9172C51.906 26.1965 51.2222 24.5464 50.0053 23.3298C48.7884 22.1131 47.1381 21.4297 45.4174 21.4297ZM45.4174 27.9172V32.2428H6.48756V27.9172H45.4174ZM6.48756 53.8705V38.7318H45.4174V53.8705H6.48756Z",
    fill: "#63ADF2"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2601 17.0403L49.7422 12.7791L58.2601 8.51791L62.5213 0L66.7825 8.51791L75.3004 12.7791L66.7825 17.0403L62.5213 25.5582L58.2601 17.0403Z",
    fill: "#63ADF2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1189_12466"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75.3026,
    height: 60.36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature2);
export default __webpack_public_path__ + "static/media/feature-2.cf7135b946d76864f614aacce13e1a29.svg";
export { ForwardRef as ReactComponent };